// components/CameraPermissionPage.js
import React, { useRef, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useQuiz } from '../context/QuizContext';

const CameraPermissionPage = () => {
  const videoRef = useRef(null);
  const navigate = useNavigate();
  const { dispatch } = useQuiz();
  const [cameraActive, setCameraActive] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    startCamera();
  }, []);

  const startCamera = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ 
        video: { 
          width: 640, 
          height: 480,
          facingMode: 'user'
        } 
      });
      
      if (videoRef.current) {
        videoRef.current.srcObject = stream;
        setCameraActive(true);
        setError('');
      }
    } catch (err) {
      setError('Failed to access camera. Please allow camera permissions.');
      console.error('Camera error:', err);
    }
  };

  const handleStartQuiz = () => {
    if (cameraActive) {
      dispatch({ type: 'START_QUIZ' });
      navigate('/quiz');
    } else {
      alert('Please enable camera to continue');
    }
  };

  return (
    <div className="camera-page">
      <div className="camera-container">
        <h1>Camera Setup</h1>
        <p>Camera access is required to continue with the quiz.</p>
        
        <div className="camera-feed">
          <video
            ref={videoRef}
            autoPlay
            playsInline
            muted
            className="camera-video"
          />
        </div>

        {error && <div className="error-message">{error}</div>}

        <div className="camera-status">
          <span className={`status-indicator ${cameraActive ? 'active' : 'inactive'}`}>
            ● {cameraActive ? 'Camera Active' : 'Camera Inactive'}
          </span>
        </div>

        <button 
          onClick={handleStartQuiz} 
          className="btn-primary"
          disabled={!cameraActive}
        >
          Start Quiz
        </button>

        <button onClick={startCamera} className="btn-secondary">
          Retry Camera
        </button>
      </div>
    </div>
  );
};

export default CameraPermissionPage;